<script>
    export default {
        props: {
            productId: null,
            nextProduct: null,
            previousProduct: null,
        },
        methods: {
            showProduct(id) {
                window.location.href = window.location.href.replace(this.productId, id);
            },
        }
    }
</script>

<template>
    <div class="row">
        <div class="col-md-12 p-sm bg-muted">
            <div class="col-md-4 text-left">
                <div v-if="previousProduct">
                    <button class="btn btn-success btn-sm" @click="showProduct(previousProduct.id)">
                        <i class="fa fa-angle-left fa-2x"></i>
                    </button>
                    <small class="block">{{ previousProduct.product_name }}</small>
                </div>
                <div v-else>
                    <button class="btn btn-success btn-sm disabled">
                        <i class="fa fa-angle-left fa-2x"></i>
                    </button>
                </div>
            </div>
            <div class="col-md-4 text-center" style="line-height: 58px">
                <slot></slot>
            </div>
            <div class="col-md-4 text-right">
                <div v-if="nextProduct">
                    <button class="btn btn-success btn-sm" @click="showProduct(nextProduct.id)">
                        <i class="fa fa-angle-right fa-2x"></i>
                    </button>
                    <small class="block">{{ nextProduct.product_name }}</small>
                </div>
                <div v-else>
                    <button class="btn btn-success btn-sm disabled">
                        <i class="fa fa-angle-right fa-2x"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
